import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
const STATUS_CONFIG = {
    pending: { labelKey: 'status.pending', className: 'text-muted-foreground' },
    claimed: { labelKey: 'status.claimed', className: 'text-blue-400' },
    in_progress: { labelKey: 'status.in_progress', className: 'text-blue-400' },
    preliminary: { labelKey: 'status.preliminary', className: 'text-amber-400' },
    final: { labelKey: 'status.final', className: 'text-emerald-400' },
    delivered: { labelKey: 'status.delivered', className: 'text-emerald-400' },
    amended: { labelKey: 'status.amended', className: 'text-purple-400' },
    cancelled: { labelKey: 'status.cancelled', className: 'text-zinc-500 line-through' },
    // Deleted cases vanish from every list; rendered defensively if one is ever
    // still in a stale cache when its row re-renders.
    deleted: { labelKey: 'status.deleted', className: 'text-zinc-600 line-through' },
};
export function CaseStatusBadge({ status }) {
    const { t } = useTranslation('teleconsultation');
    const config = STATUS_CONFIG[status];
    return _jsx("span", { className: cn('text-xs font-medium', config.className), children: t(config.labelKey) });
}
